import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { useParams } from 'react-router-dom';

import FrequencyType from './frequencyType';
import DurationType from './durationType';
import { errorNormalizer } from '../../../../../shared/Helpers/functions';

import { DispatchProperties, useSelector } from '../../../../../redux/store';
import { getBehaviors } from '../../../../../redux/State/clientSlice/behaviorReductionSlice';
import { RecordingType } from '../../../../../redux/API/ClientAPIHelpers/behaviorReductionProperties';
import { isElcFunder } from '../../../../../redux/API/constants';

const Behaviours = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const { clientId } = useParams();

	const behaviors = useSelector((state) => state.behaviorReduction.behaviors);
	// ELC sessions show ELC behaviors; insurance AND DOE sessions both share the default (null)
	// pool, so any non-ELC session normalizes its funder to null.
	const funderId = useSelector((state) => state.session.sessionInfo.sessionType?.funderId);
	const dataFunderId = isElcFunder(funderId) ? funderId : null;

	useEffect(() => {
		if (!clientId) return;
		dispatch(getBehaviors({ clientId, includeArchived: false, funderId: dataFunderId }))
			.then(unwrapResult)
			.catch(errorNormalizer);
	}, [clientId, dataFunderId, dispatch]);

	return (
		<div className="behaviorWrapper">
			{behaviors.map((x) => (
				<div key={x.id} className="behavior">
					{RecordingType.frequency === x.recordingType.id && <FrequencyType behavior={x} />}
					{RecordingType.duration === x.recordingType.id && <DurationType behavior={x} />}
				</div>
			))}
		</div>
	);
};

export default Behaviours;
